import { ModuleWithProviders, NgModule } from '@angular/core'

import { AnalyticsEventDirective } from './analytics-event.directive'
import { AnalyticsConfig, AnalyticsService } from './analytics.service'

@NgModule({
  imports: [AnalyticsEventDirective],
  exports: [AnalyticsEventDirective],
  providers: [AnalyticsService],
})
export class AnalyticsModule {
  static forRoot(analyticsConfig: AnalyticsConfig): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [AnalyticsService, { provide: 'ANALYTICS_CONFIG', useValue: analyticsConfig }],
    }
  }
}
